var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6577 20C13.0343 20 14.2342 19.0412 14.5681 17.6745L16 11.813H20.5C21.3284 11.813 22 11.1257 22 10.2779C22 9.43013 21.3284 8.74285 20.5 8.74285H11.5L13.5747 7.41588C14.5596 6.78588 14.7159 5.38195 13.8946 4.54143C13.3575 3.99183 12.5418 3.84477 11.8536 4.17346L5.5 7.20779C3.3767 8.13905 2 10.2757 2 12.6398V14.8831C2 17.7091 4.23858 20 7 20H11.6577Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerRight);
export default __webpack_public_path__ + "static/media/pointer-right.55b6a531ea470333be0cdd820d135a6b.svg";
export { ForwardRef as ReactComponent };